import TotalScore from './model';

export default TotalScore;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/TotalScore/index.js